import { View, Text, StyleSheet, ScrollView, TouchableOpacity } from 'react-native';
import { useTheme } from '@/contexts/ThemeContext';

export type TimeframeFilter = 'all' | '7d' | '30d' | '90d';
export type StatusFilter = 'all' | 'completed' | 'cancelled' | 'declined' | 'expired';

interface DuelHistoryFiltersProps {
  timeframeFilter: TimeframeFilter;
  statusFilter: StatusFilter;
  onTimeframeChange: (tf: TimeframeFilter) => void;
  onStatusChange: (sf: StatusFilter) => void;
}

const TIMEFRAMES: { key: TimeframeFilter; label: string }[] = [
  { key: 'all', label: 'All Time' },
  { key: '7d', label: '7 Days' },
  { key: '30d', label: '30 Days' },
  { key: '90d', label: '90 Days' },
];

const STATUSES: { key: StatusFilter; label: string }[] = [
  { key: 'all', label: 'All Status' },
  { key: 'completed', label: 'Completed' },
  { key: 'cancelled', label: 'Cancelled' },
  { key: 'declined', label: 'Declined' },
  { key: 'expired', label: 'Expired' },
];

export default function DuelHistoryFilters({
  timeframeFilter,
  statusFilter,
  onTimeframeChange,
  onStatusChange,
}: DuelHistoryFiltersProps) {
  const { theme } = useTheme();

  return (
    <View style={styles.filterBar}>
      <ScrollView horizontal showsHorizontalScrollIndicator={false} style={styles.filterRow}>
        {TIMEFRAMES.map(({ key, label }) => (
          <TouchableOpacity
            key={key}
            onPress={() => onTimeframeChange(key)}
            style={[
              styles.filterChip,
              { borderColor: theme.colors.border },
              timeframeFilter === key && { backgroundColor: theme.colors.accent },
            ]}>
            <Text
              style={[
                styles.filterChipText,
                { color: timeframeFilter === key ? theme.colors.background : theme.colors.textSecondary },
              ]}>
              {label}
            </Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
      <ScrollView horizontal showsHorizontalScrollIndicator={false} style={styles.filterRow}>
        {STATUSES.map(({ key, label }) => (
          <TouchableOpacity
            key={key}
            onPress={() => onStatusChange(key)}
            style={[
              styles.filterChip,
              { borderColor: theme.colors.border },
              statusFilter === key && { backgroundColor: theme.colors.accent },
            ]}>
            <Text
              style={[
                styles.filterChipText,
                { color: statusFilter === key ? theme.colors.background : theme.colors.textSecondary },
              ]}>
              {label}
            </Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  filterBar: {
    paddingHorizontal: 16,
    paddingBottom: 8,
    gap: 6,
  },
  filterRow: {
    flexDirection: 'row',
    marginBottom: 4,
  },
  filterChip: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 4,
    borderWidth: 1,
    marginRight: 8,
  },
  filterChipText: {
    fontSize: 13,
    fontWeight: '500',
  },
});
